import { useQuery } from "@apollo/client";
import { createContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { listSweepstakesActive } from "../graphql/queries/listSweepstakesActive";

const ListSweepstakesContext = createContext();

const ListSweepstakesProvider = ({ children }) => {
  const [sweepstakesList, setSweepstakesList] = useState();
  const [totalCount, setTotalCount] = useState(0);
  const [isLoading, setLoading] = useState(false);
  const location = useLocation();

  const defaultPage = 0;
  const defaultSize = 10;

  const { data, loading, refetch } = useQuery(listSweepstakesActive, {
    variables: {
      filter: {
        statusIn: "CREATED, ACTIVE, COMPLETED, WINNER_PICKED, WINNER_CONFIRMED",
        page: defaultPage,
        size: defaultSize,
      },
    },
    onCompleted: () => {
      setLoading(false);
    },
    onError: (err) => {
      console.error(err);
      setLoading(false);
    },
  });

  useEffect(() => {
    if (data && data?.listSweepstakesLatest) {
      if (data.listSweepstakesLatest.items) {
        setSweepstakesList(data.listSweepstakesLatest.items);
      }
      setTotalCount(data.listSweepstakesLatest.total);
    }
    setLoading(false);
  }, [data]);

  useEffect(() => {
    if (loading === false && isLoading === true) {
      setLoading(false);
    }
  }, [loading, isLoading]);

  useEffect(() => {
    const refreshSweepstakes = async () => {
      if (
        listSweepstakesActive &&
        location.pathname === "/sweepstakes/winners-management"
      ) {
        await refetch({
          filter: {
            statusIn: "CREATED, ACTIVE, COMPLETED, WINNER_PICKED, WINNER_CONFIRMED",
            page: defaultPage,
            size: defaultSize,
          },
        });
      }
    };
    refreshSweepstakes();
  }, [location.pathname, refetch]);

  const contextValue = {
    loading,
    sweepstakesList,
    totalCount,
    refetch,
  };

  return (
    <ListSweepstakesContext.Provider value={contextValue}>
      {children}
    </ListSweepstakesContext.Provider>
  );
};

export { ListSweepstakesContext, ListSweepstakesProvider };
